import script from "./EditShippingMethod.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditShippingMethod.vue?vue&type=script&setup=true&lang=ts"

import "./EditShippingMethod.vue?vue&type=style&index=0&id=71b55e20&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71b55e20"]])

export default __exports__